module.exports = __webpack_public_path__ + "static/media/syncc.ce9159b9.png";